import React, { ForwardedRef } from 'react';
import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton';

export const IconButton = React.forwardRef((props: IconButtonProps, ref: ForwardedRef<HTMLButtonElement | null>) => (
  <MuiIconButton ref={ref} {...props} />
));

IconButton.displayName = 'IconButton';
